"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userAppsStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.apps;
});
var loadUserAppsSelector = (0, _reselect.createSelector)(userAppsStateSelector, function (userApps) {
  return userApps.loadUserApps;
});
var loadUserAppsDataSelector = (0, _reselect.createSelector)(loadUserAppsSelector, function (loadUserApps) {
  return loadUserApps.data;
});
var loadUserAppsIsLoadingSelector = (0, _reselect.createSelector)(loadUserAppsSelector, function (loadUserApps) {
  return loadUserApps.isLoading;
});
var loadUserAppsErrorSelector = (0, _reselect.createSelector)(loadUserAppsSelector, function (loadUserApps) {
  return loadUserApps.error;
});
var pullUserAppsSelector = (0, _reselect.createSelector)(userAppsStateSelector, function (userApps) {
  return userApps.pullUserApps;
});
var pullUserAppsSuccessSelector = (0, _reselect.createSelector)(pullUserAppsSelector, function (pullUserApps) {
  return pullUserApps.success;
});
var pullUserAppsIsLoadingSelector = (0, _reselect.createSelector)(pullUserAppsSelector, function (pullUserApps) {
  return pullUserApps.isLoading;
});
var pullUserAppsErrorSelector = (0, _reselect.createSelector)(pullUserAppsSelector, function (pullUserApps) {
  return pullUserApps.error;
});
var deleteUserAppSelector = (0, _reselect.createSelector)(userAppsStateSelector, function (userApps) {
  return userApps.deleteUserApp;
});
var deletedUserAppNameSelector = (0, _reselect.createSelector)(deleteUserAppSelector, function (deleteUserApp) {
  return deleteUserApp.deletedAppName;
});
var deleteUserAppIsLoadingSelector = (0, _reselect.createSelector)(deleteUserAppSelector, function (deleteUserApp) {
  return deleteUserApp.isLoading;
});
var deleteUserAppErrorSelector = (0, _reselect.createSelector)(deleteUserAppSelector, function (deleteUserApp) {
  return deleteUserApp.error;
});
var _default = {
  loadUserAppsDataSelector: loadUserAppsDataSelector,
  loadUserAppsIsLoadingSelector: loadUserAppsIsLoadingSelector,
  loadUserAppsErrorSelector: loadUserAppsErrorSelector,
  pullUserAppsSuccessSelector: pullUserAppsSuccessSelector,
  pullUserAppsIsLoadingSelector: pullUserAppsIsLoadingSelector,
  pullUserAppsErrorSelector: pullUserAppsErrorSelector,
  deletedUserAppNameSelector: deletedUserAppNameSelector,
  deleteUserAppIsLoadingSelector: deleteUserAppIsLoadingSelector,
  deleteUserAppErrorSelector: deleteUserAppErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map